if (!customElements.get('intro-vimeo-background')) {
  customElements.define('intro-vimeo-background', class extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('iframe');
      if (!this.frame) return;
      this.origin = new URL(this.frame.dataset.src).origin;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = matchMedia('(min-width: 768px)');
      this.near = false;
      this.ready = false;
      this.send = (method, value) => this.frame.contentWindow?.postMessage({ method, value }, this.origin);
      this.update = () => {
        const play = this.near && this.desktop.matches && !this.motion.matches && !navigator.connection?.saveData && !document.hidden && !document.querySelector('#video-modal[open]');
        if (play && !this.frame.hasAttribute('src')) this.frame.src = this.frame.dataset.src;
        if (!this.ready) return;
        this.send(play ? 'play' : 'pause');
      };
      this.onMessage = (event) => {
        if (event.source !== this.frame.contentWindow || event.origin !== this.origin) return;
        let data = event.data;
        if (typeof data === 'string') {
          try { data = JSON.parse(data); } catch { return; }
        }
        if (data?.event === 'ready') {
          this.send('setQuality', '360p');
          return;
        }
        if (data?.method !== 'setQuality' && !(data?.event === 'error' && data.data?.method === 'setQuality')) return;
        this.ready = true;
        this.frame.hidden = false;
        this.update();
      };
      addEventListener('message', this.onMessage);
      this.observer = new IntersectionObserver(([entry]) => {
        this.near = entry.isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      this.motion.addEventListener('change', this.update);
      this.desktop.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);
      this.modalObserver = new MutationObserver(this.update);
      const modal = document.getElementById('video-modal');
      if (modal) this.modalObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
    }

    disconnectedCallback() {
      removeEventListener('message', this.onMessage);
      this.observer?.disconnect();
      this.modalObserver?.disconnect();
      this.motion?.removeEventListener('change', this.update);
      this.desktop?.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
}
